/* eslint-disable no-console */
import { Component } from 'js-component-framework';
import AriaPopup from 'js-component-framework/lib/plugins/AriaPopup';

/**
 * One-off subclass to modify part of the popup's focus management strategy.
 */
class KauffmanAriaPopup extends AriaPopup {
  /**
  * Collect all interactive child elements.
  */
  collectInteractiveChildren() {
    if (undefined === this.targetElement) {
      // eslint-disable-next-line no-console
      console
        .error('No `targetElement` specified for collectInteractiveChildren');
      return;
    }

    const interactiveElements =
      this.targetElement.querySelectorAll(this.selectors);
    this.interactiveChildElements = Array.prototype.filter.call(
      interactiveElements,
      (child) => {
        // Makes sure the controllers inside the nested popups aren't disabled.
        if (child.classList.contains('nav__toggle')) {
          return false;
        }
        return this.constructor.isVisible(child);
      }
    );
  }
}

/**
 * Component for toggling something on/off using AriaPopup.
 */
export default class Toggle extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    const { target, controller } = this.children;

    // Bail if no target
    if (! controller || ! target) {
      return;
    }

    this.popup = new KauffmanAriaPopup({
      controller,
      target,
    });
  }
}
